const CHATBOT_URL = process.env.REACT_APP_CHATBOT_URL || 'https://dcps-hades-ai-dev.azurewebsites.net';

export function processMarkers(
    content: string,
    profileCards?: Record<string, string>,
    htmlTables?: Record<string, string>,
): string {
    let processed = content;

    // {{TABLE:tableId}} → injected HTML
    processed = processed.replace(/\{\{TABLE:([^}]+)\}\}/g, (_match, tableId) => {
        if (htmlTables?.[tableId]) {
            return `<div class="chat-html-table">${htmlTables[tableId]}</div>`;
        }
        return '';
    });

    // {{PROFILE:profileId}} → injected profile card HTML
    processed = processed.replace(/\{\{PROFILE:([^}]+)\}\}/g, (_match, profileId) => {
        if (profileCards?.[profileId]) {
            let cardHtml = profileCards[profileId];
            cardHtml = processMapMarkers(cardHtml);
            // Rewrite relative /api/ URLs to chatbot backend
            cardHtml = cardHtml.replace(/src=['"]\/api\//g, `src='${CHATBOT_URL}/api/`);
            cardHtml = cardHtml.replace(/href=['"]\/api\//g, `href='${CHATBOT_URL}/api/`);
            return `<div class="chat-profile-card">${cardHtml}</div>`;
        }
        return '';
    });

    // {{PHOTO:ownerId:ownerType}} → img tag
    const profileIds = profileCards ? new Set(Object.keys(profileCards)) : new Set<string>();
    processed = processed.replace(/\{\{PHOTO:([^:}]+):([^}]+)\}\}/g, (_match, ownerId, ownerType) => {
        if (profileIds.has(ownerId)) return '';
        return `<div class="chat-photo-container"><img src="${CHATBOT_URL}/api/photo-img/${ownerId}/${ownerType}" alt="Photo" class="chat-photo" onerror="this.style.display='none'" /></div>`;
    });

    return processed;
}

function processMapMarkers(html: string): string {
    return html.replace(/\{\{MAP:([^:]+):([^:]+):([^}]+)\}\}/g, (_match, lat, lon, address) => {
        const decoded = decodeURIComponent(address.replace(/\+/g, ' '));
        const googleUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(decoded)}`;
        const osmUrl = `https://www.openstreetmap.org/?mlat=${lat}&mlon=${lon}#map=17/${lat}/${lon}`;
        const embedUrl = `https://www.openstreetmap.org/export/embed.html?bbox=${parseFloat(lon) - 0.005},${parseFloat(lat) - 0.003},${parseFloat(lon) + 0.005},${parseFloat(lat) + 0.003}&layer=mapnik&marker=${lat},${lon}`;
        return `<div class="chat-map-container">
            <iframe width="100%" height="180" frameborder="0" scrolling="no" src="${embedUrl}" style="border:0;display:block;border-radius:8px 8px 0 0;" loading="lazy"></iframe>
            <div style="padding:8px;display:flex;gap:6px;flex-wrap:wrap;">
                <a href="${googleUrl}" target="_blank" rel="noopener noreferrer" class="chat-map-link chat-map-directions">Get Directions</a>
                <a href="${osmUrl}" target="_blank" rel="noopener noreferrer" class="chat-map-link chat-map-view">View Map</a>
            </div>
        </div>`;
    });
}

export function hasMarkers(content: string): boolean {
    return /\{\{(PROFILE|PHOTO|TABLE|MAP):[^}]+\}\}/.test(content);
}

export function hasHtmlContent(content: string): boolean {
    return /<(div|span|table|img|a|ul|ol|h[1-6]|p|br|hr)\b/i.test(content);
}

export function toggleProfileCard(el: HTMLElement): void {
    const card = el.closest('.profile-card-collapsible');
    if (card) card.classList.toggle('expanded');
}

export function installGlobalHandlers(): void {
    (window as unknown as Record<string, unknown>).toggleProfileCard = toggleProfileCard;
}
